import React, { useEffect, useState } from "react";

import I from "./Icon";

import BC from "./Breadcrumb";

import apiService from "../services/apiService";

const getBookId = (book) =>

  book?.id ?? book?.Id ?? book?.bookId ?? book?.BookId ?? book?.bookMasterId ?? book?.BookMasterId ?? 0;

const unwrap = (value) => {

  let current = value;

  for (let i = 0; i < 6; i += 1) {

    if (typeof current === "string") {

      try { current = JSON.parse(current); } catch { break; }

    }

    if (Array.isArray(current)) return current[0] ?? null;

    if (!current || typeof current !== "object") break;

    const next = current.output ?? current.Output ?? current.result ?? current.Result ?? current.data ?? current.Data ??

      current.book ?? current.Book ?? current.bookMaster ?? current.BookMaster;

    if (next == null) break;

    current = next;

  }

  return current;

};

const normalizeBook = (book, fallback) => {

  if (!book && !fallback) return null;

  const record = { ...(fallback || {}), ...(book || {}) };

  // usp_GetBookMasterById returns the details under teaBooAssDetlst.
  // SQL FOR JSON PATH can return the nested array as a JSON string.
  const rawDetails = record.teaBooAssDetlst ?? record.TeaBooAssDetlst ??
    record.bokDetlst ?? record.BokDetlst ?? record.BokDetLst ??
    record.bookMasterDetails ?? record.BookMasterDetails ?? record.bookMasterDetail ??
    record.BookMasterDetail ?? record.details ?? record.Details ?? [];

  let parsedDetails = rawDetails;
  if (typeof parsedDetails === "string") {
    try {
      parsedDetails = JSON.parse(parsedDetails);
    } catch {
      parsedDetails = [];
    }
  }
  const details = Array.isArray(parsedDetails)
    ? parsedDetails
    : parsedDetails && typeof parsedDetails === "object"
      ? [parsedDetails]
      : [];
  if (!details.length && (record.bookName ?? record.BookName)) {

    details.push({

      bookName: record.bookName ?? record.BookName,

      amount: record.amount ?? record.Amount,

      qty: record.qty ?? record.Qty,

    });

  }

  return {

    ...record,

    id: getBookId(record),

    bookCode: record.bookCode ?? record.BookCode ?? "",

    competitiveExams: record.competitiveExams ?? record.CompetitiveExams ?? "",

    totalAmount: Number(record.totalAmount ?? record.TotalAmount ?? 0),

    qty: Number(record.qty ?? record.Qty ?? 0),

    description: record.description ?? record.Description ?? record.remark ?? record.Remark ?? "",

    isActive: record.isActive ?? record.IsActive ?? true,

    details: details.map((item) => ({

      ...item,

      id: item.id ?? item.Id ?? 0,

      bookMasterId: item.bookMasterId ?? item.BookMasterId ?? getBookId(record),

      bookName: item.bookName ?? item.BookName ?? "",
      competitiveExams: item.competitiveExams ?? item.CompetitiveExams ?? record.competitiveExams ?? record.CompetitiveExams ?? "",

      amount: Number(item.amount ?? item.Amount ?? 0),

      qty: Number(item.qty ?? item.Qty ?? 0),

    })),

    // Keep detail records available when editing from the View screen.

    bokDetlst: details.map((item) => ({
      ...item,
      id: item.id ?? item.Id ?? 0,
      bookMasterId: item.bookMasterId ?? item.BookMasterId ?? getBookId(record),
      bookName: item.bookName ?? item.BookName ?? "",
      amount: Number(item.amount ?? item.Amount ?? 0),
      qty: Number(item.qty ?? item.Qty ?? 0),
      isActive: item.isActive ?? item.IsActive ?? true,
    })),

  };

};

const fieldStyle = {

  display: "flex", alignItems: "center", minHeight: 36,

  background: "#F8FAFC", padding: "9px 12px", borderRadius: 6,

};

export default function BookMasterView({ book, onBack, onEdit }) {

  const [bookDetails, setBookDetails] = useState(null);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const bookId = getBookId(book);

  useEffect(() => {

    let cancelled = false;

    const loadBookDetails = async () => {

      if (!bookId) {

        setError("Book ID not found.");

        return;

      }

      try {

        setLoading(true);

        setError("");

        const response = await apiService.get(`BookMaster/getBookMasterById/${bookId}`);

        const result = response?.data;

        if (result?.isSuccess === false || result?.IsSuccess === false) {

          throw new Error(result?.failureReason ?? result?.FailureReason ?? result?.message ?? result?.Message ?? "Failed to load book details");

        }

        if (!cancelled) setBookDetails(normalizeBook(unwrap(result), book));

      } catch (err) {

        if (!cancelled) {

          console.error("Get Book Details Error:", err?.response?.data ?? err);

          setError(err?.response?.data?.failureReason ?? err?.response?.data?.FailureReason ??

            err?.response?.data?.message ?? err?.response?.data?.Message ?? err?.message ?? "Unable to load book details.");

        }

      } finally {

        if (!cancelled) setLoading(false);

      }

    };

    loadBookDetails();

    return () => { cancelled = true; };

  }, [bookId]);

  const field = (label, value, full = false) => (

    <div className={`fg${full ? " fall" : ""}`} key={label}>

      <label className="fl">{label}</label>

      <div className="fi" style={fieldStyle}>{value ?? "-"}</div>

    </div>

  );

  return (

    <>

      <BC items={["Book Master", "View Book"]} onBack={onBack} />

      <div className="card cp" style={{ maxWidth: 680 }}>

        {loading ? (

          <div style={{ textAlign: "center", padding: 30 }}>Loading book details...</div>

        ) : error ? (

          <div>

            <div style={{ color: "#dc2626", marginBottom: 16 }}>{error}</div>

            <button type="button" className="btn btn-g" onClick={onBack}>Back</button>

          </div>

        ) : bookDetails ? (

          <>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 18 }}>

              <div style={{ fontWeight: 700, fontSize: 15 }}>Book Details</div>

              {onEdit && (

                <button type="button" className="btn btn-g btn-sm" onClick={() => onEdit(bookDetails)}>

                  <I n="edit" s={11} /> Edit

                </button>

              )}

            </div>

            <div className="fsec">

              <div className="fsec-t"><I n="book" s={14} c="var(--p)" /> Book Information</div>

              <div className="fgrid">

                {field("Book Code", bookDetails.bookCode || "-")}

                {field("CompetitiveExams", bookDetails.competitiveExams || "-")}

                {field("Total Amount", `₹${bookDetails.totalAmount.toLocaleString("en-IN")}`)}

                {field("Total Quantity", bookDetails.qty)}

                {field("Description", bookDetails.description || "-", true)}

              </div>

            </div>

            <div className="fsec" style={{ marginTop: 16 }}>

              <div className="fsec-t"><I n="book" s={14} c="var(--p)" /> Book Master Details</div>

              {bookDetails.details.length ? (

                <div className="tw" style={{ overflowX: "auto" }}>

                  <table>

                    <thead><tr><th>Book/QuestionSet Name</th><th>CompetitiveExams</th><th>Amount</th><th>Quantity</th></tr></thead>

                    <tbody>

                      {bookDetails.details.map((detail, index) => (

                        <tr key={detail.id || index}>

                          <td>{detail.bookName || "-"}</td>
                            <td>{detail.competitiveExams || "-"}</td>

                          <td>₹{detail.amount.toLocaleString("en-IN")}</td>

                          <td>{detail.qty}</td>

                        </tr>

                      ))}

                    </tbody>

                  </table>

                </div>

              ) : (

                <div style={{ color: "var(--t3)", padding: "12px 0" }}>

                  Book detail records were not included in the API response.

                </div>

              )}

            </div>

            <div style={{ display: "flex", gap: 9, marginTop: 18 }}>

              <button type="button" className="btn btn-g" onClick={onBack}>Back</button>

              {onEdit && (

                <button type="button" className="btn btn-p" onClick={() => onEdit(bookDetails)}>

                  <I n="edit" s={12} c="#fff" /> Edit Book

                </button>

              )}

            </div>

          </>

        ) : (

          <div style={{ padding: 20 }}>Book details not found.</div>

        )}

      </div>

    </>

  );

}
